import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useUrlFilters } from "~/features/filter";

import { contestTerritoriesFilterFields } from "./fields";

interface ContestTerritoriesFilterValues {
  /** Дата действия (yyyy-MM-dd) — территории, чей период конкурса её покрывает. */
  date?: string;
  /** ИД региона (geoPlaceId, в query уходит строкой). */
  geoPlaceId?: string;
}

/**
 * Возвращает значения фильтра конкурсных территорий из URL,
 * приведённые к типам, готовым для передачи в API.
 */
export const useContestTerritoriesFilterValues =
  (): ContestTerritoriesFilterValues => {
    const { t } = useTranslation();
    const fields = useMemo(() => contestTerritoriesFilterFields(t), [t]);
    const { values } = useUrlFilters(fields);

    return useMemo<ContestTerritoriesFilterValues>(
      () => ({
        date: (values.date as string) || undefined,
        geoPlaceId: (values.geoPlaceId as string) || undefined,
      }),
      [values],
    );
  };
